export default {
  namespaced: true,
  state: {
    maintenance: false,
    // Compañía con «Tiene SegElevia = No»: las consultas a SegElevia están cortadas
    segEleviaOff: false
  },
  mutations: {
    SET_MAINTENANCE (state, val) { state.maintenance = !!val },
    SET_SEGELEVIA_OFF (state, val) { state.segEleviaOff = !!val }
  },
  getters: {
    isMaintenance: state => state.maintenance,
    isSegEleviaOff: state => state.segEleviaOff
  }
}
